<template>
    <el-dialog title="配置产品信息示例" width="60%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <div class="p_all1">
            <div class="title">一、产品标题</div>
            <img src="@/assets/img/productName.jpg" class="img">
            <div class="title">二、登录页LOGO</div>
            <img src="@/assets/img/loginLogo.jpg" class="img">
            <div class="title">三、登录页背景图</div>
            <img src="@/assets/img/loginBackground.jpg" class="img">
            <div class="title">四、产品LOGO</div>
            <img src="@/assets/img/productLogo.jpg" class="img">
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false
            }
        },
        methods: {
            init() {
                this.visible = true
            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #000;
    }
    .img {
        width: 100%;
        margin-bottom: 20px;
    }
</style>
